import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useLocation, useNavigate } from "react-router-dom";

const ThankYouPage = ({ message = "Thank you!", onBackToHome }) => {
  const location = useLocation();
  let navigate = useNavigate();
  const { downloadLink } = location.state || {};
  console.log("downloadLink", downloadLink);
  const handleDownload = () => {
    window.open(downloadLink, "_blank");
    navigate("/");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#f9f9f9",
        padding: 3,
      }}
    >
      <CheckCircleOutlineIcon
        sx={{
          fontSize: 80,
          color: "green",
          marginBottom: 2,
        }}
      />
      <Typography variant="h4" component="h1" gutterBottom>
        {message}
      </Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        Your assessment has been successfully generated!
      </Typography>
      {downloadLink && (
        <Button
          variant="contained"
          color="primary"
          sx={{
            color: "#fff",
            backgroundColor: "#b19777",
            borderRadius: 0,
            fontSize: "0.8rem",
            padding: "5px 35px",
          }}
          onClick={handleDownload}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download Your PDF
        </Button>
      )}
    </Box>
  );
};

export default ThankYouPage;
